import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, withLatestFrom } from "rxjs";
import { map, filter, distinctUntilChanged } from "rxjs/operators";
import { ApiSessionState } from "../api-session.service";
import { ApiStateStoreService } from "../api-state-store.service";
import { UserService } from "../resources/user/user.service";
import { userId } from "./user-id";

@Injectable({ providedIn: "root" })
export class CurrentOrganizationService {
  static currentOrgId = new BehaviorSubject<string>("");
  /** org id when first logged in */
  firstOrgId = "";
  /** the org id switched to while in the admin tab */
  adminOrgId = "";

  constructor() {
    const store = inject(ApiStateStoreService);

    // get current org based of userId
    store.state
      .pipe(
        withLatestFrom(store.state.pipe(userId()), UserService.usersById),
        map(
          ([store, selfUserId, usersById]) =>
            (store.Session?.state as ApiSessionState).organizationId ||
            usersById[selfUserId]?.organizationId
        ),
        distinctUntilChanged(),
        filter(<T>(val: T): val is NonNullable<T> => !!val)
      )
      .subscribe(orgId => {
        this.firstOrgId = orgId;
        CurrentOrganizationService.currentOrgId.next(orgId);
      });
  }

  /** switch stored current org id to requested new org id */
  switchCurrentOrg(orgId: string): void {
    CurrentOrganizationService.currentOrgId.next(orgId);
    // save orgId when we need to come back to the admin page
    this.adminOrgId = CurrentOrganizationService.currentOrgId.value.slice();
  }
}
